import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Music2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/download";

const SIAE_MACROS = ["Cantanti e interpreti", "Gruppi musicali e band", "DJ e musica elettronica", "Musicisti e strumentisti", "Orchestre, cori e bande", "Teatro e recitazione", "Comicità e varietà", "Musical e grandi produzioni"];
const input = "w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-gold";
const FIELDS = [["number", "Numero di iscrizione SIAE"], ["position", "Posizione SIAE"], ["email", "Email SIAE per invio borderò post evento"]];

export const needsSiae = (user) => Object.keys(user.taxonomy?.artist || {}).some((m) => SIAE_MACROS.includes(m));

export const SiaeCard = () => {
  const { user } = useAuth();
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/siae").then((r) => setV({ number: "", position: "", email: "", ...r.data })); }, []);
  if (!v || !needsSiae(user)) { return null; }
  const save = async () => {
    setBusy(true);
    try { await api.put("/siae", { number: v.number || null, position: v.position || null, email: v.email || null }); toast.success("Dati SIAE salvati"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-8 card-premium p-6" data-testid="siae-card">
      <h3 className="font-display text-xl font-bold flex items-center gap-2 mb-1"><Music2 className="w-5 h-5 text-gold"/>Dati SIAE</h3>
      <p className="text-sm text-slate-600 mb-4">Visibili solo a te, all'amministrazione e ai committenti che ti ingaggiano.</p>
      <div className="grid md:grid-cols-3 gap-3">
        {FIELDS.map(([k, l]) => (
          <label key={k} className="text-xs text-slate-600">{l} (facoltativo)
            <input type={k === "email" ? "email" : "text"} maxLength={k === "email" ? 120 : 60} value={v[k] || ""} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`siae-${k}`} className={`${input} mt-1`}/></label>
        ))}
      </div>
      <p className="mt-4 text-sm text-aic-navy bg-[#FBF6EE] border border-gold/40 rounded-xl px-4 py-3" data-testid="siae-note">Compilare questi campi è facoltativo, ma ogni dettaglio aggiuntivo aumenta le tue possibilità di ingaggio.</p>
      <button onClick={save} disabled={busy} data-testid="siae-save" className="btn-pill-gold text-sm mt-4">{busy ? "Salvataggio…" : "Salva"}</button>
    </div>
  );
};

export const SiaeInfo = ({ uid, testId = "siae-info" }) => {
  const [d, setD] = useState(null);
  const load = async () => { try { setD((await api.get(`/siae/${uid}`)).data); } catch (e) { toast.error(errMsg(e)); } };
  if (!d) { return <button type="button" onClick={load} data-testid={`${testId}-open`} className="text-xs font-semibold text-[#C98A3C] hover:underline inline-flex items-center gap-1"><Music2 className="w-3.5 h-3.5"/>Dati SIAE</button>; }
  const rows = FIELDS.filter(([k]) => d[k]);
  return (
    <div className="text-xs text-slate-600" data-testid={testId}>
      {rows.length ? rows.map(([k, l]) => <div key={k}><span className="text-slate-400">{l}:</span> {k === "email" ? <a href={`mailto:${d[k]}`} className="underline">{d[k]}</a> : d[k]}</div>) : <span>Dati SIAE non indicati dall'artista</span>}
    </div>
  );
};
